import tenant from "@/helpers/tenant";
import mixpanel from 'mixpanel-browser';

let tracker = mixpanel;
if( /^http:\/\/localhost/.test(window.location.href) ){
    tracker = {track: () => {}};
}

export default {

    data(){
        return {
            mixpanel: tracker,
        }
    },

    computed: {

        app_name(){
            return this.$page.props?.app_name;
        },

        active_tenant() {
            return typeof this.$page.props.active_tenant !== 'undefined' ? (this.$page.props.active_tenant === false ? null : this.$page.props.active_tenant) : null;
        },

        global_url_params() {
            const tenant_handle = this.active_tenant?.handle ? this.active_tenant?.handle : 'app';
            return {tenant_handle};
        },

        theme_logo() {
            return tenant.theme_logo(this.active_tenant);
        },

        theme_background() {
            return tenant.theme_background(this.active_tenant);
        },

        is_admin(){
            return this.$page.props?.user?.is_admin;
        },

        is_paid(){
            if (this.$page.props.user.derived_account_type == 'paid') {
                return true;
            } else {
                return false;
            }
        },

        is_free(){
            if (this.$page.props.user.derived_account_type == 'free') {
                return true;
            } else {
                return false;
            }
        },

        is_teacher(){
            return this.$page.props?.user?.is_teacher;
        },

        is_student(){
            return this.$page.props?.user?.is_student;
        },

        current_user_id(){
            return this.current_user?.id;
        },

        current_user(){
            return this.$page.props?.user;
        },

        user_organizations(){
            return this.current_user?.organizations ?? [];
        },

        current_user_is_paid(){
            return this.is_admin || this.current_user.derived_account_type === 'paid';
        },

        current_user_is_free(){
            return this.is_admin || this.current_user.derived_account_type === 'free';
        },

        has_edit_access(){
            return this.$page?.props?.editable;
        },

        is_impersonating(){
            return !!this.$page?.props?.impersonator;
        },

        impersonator(){
            return this.$page?.props?.impersonator;
        },

        urlParams(){
            return new URLSearchParams(window.location.search);
        },

    },


    methods: {
        setTitle(str){
            if( this.is_impersonating ) str += ` [IMP: ${this.$page.props.user.name}]`;
            str += ` | ${this.app_name}`;
            document.title = str;
        },

        currentUserAccountTypeIs(...types){

            if( types.length && Array.isArray( types[0] ) ){
                types = types[0];
            }

            if( typeof types === 'string' ) return this.current_user?.derived_account_type === types;
            if( Array.isArray(types) ){
                for ( let i = 0; i < types.length; i++ ){
                    if( this.current_user?.derived_account_type === types[i] ) return true;
                }
            }
            return false;
        },


        // trackPageVisit(){
        //     // console.log('Track');
        //     console.log( this.mixpanel );
        //     // this.mixpanel.track('Page Visit');
        // }

    },

    mounted() {
        // if( ! mixpanel_event_attached ){
        //     this.trackPageVisit();
        //     document.addEventListener('popstate', this.trackPageVisit);
        //     mixpanel_event_attached = true;
        // }
    },

}
